import React from "react";
import styles from "./TableCartPage.module.css";
import history from "../../../core/helper/Helper";
import { CartStep, CartTable, CartTotal } from "../../../components/Cart";
import Grid from "@material-ui/core/Grid";

const CartPage = () => {
  const handleCheckoutCart = () => {
    history.push("/payment/checkout");
  };

  return (
    <section className={styles.section}>
      <div className={styles.item}>
        <CartStep />
      </div>

      <div className={styles.item}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={3}>
            <CartTotal />
          </Grid>

          <Grid item xs={12} sm={9}>
            <CartTable handelDataSubmit={handleCheckoutCart} />
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default CartPage;
